import api from './api';

// Plant Orders
const getPlantOrders = () => api.get('/plantorder/plantorders/');
const createPlantOrder = (data) => api.post('/plantorder/plantorders/', data);
const updatePlantOrder = (plantOrderId, data) => api.put(`/plantorder/plantorders/${plantOrderId}/`, data);
const deletePlantOrder = (plantOrderId) => api.delete(`/plantorder/plantorders/${plantOrderId}/`);

export {
    getPlantOrders,
    createPlantOrder,
    updatePlantOrder,
    deletePlantOrder,
};
